import { BrowserRouter, Routes, Route } from "react-router-dom";
import PublicLayout from "../shared/layouts/PublicLayout";
import LoginPage from "../features/auth/pages/LoginPage";
import MfaSetupPage from "../features/auth/pages/MfaSetupPage";
import AdminLayout from "../shared/layouts/AdminLayout";
import AdminContactPage from "../features/adminContact/pages/AdminContactPage";
import MfaVerificationPage from "../features/auth/pages/MfaVerificationPage";
import DisclaimerPage from "../features/auth/pages/DisclaimerPage";
import AdminDocumentPage from "../features/adminDocument/pages/AdminDocumentPage";
import AdminEmailPage from "../features/adminEmail/pages/AdminEmailPage";
import AdminPanel from "../features/adminPanel/pages/AdminPanel";
import AssetLayout from "../shared/components/AssetHeader";
import AssetOverviewPage from "../features/assets/pages/AssetOverViewPage";
import ContactDetailsPage from "../features/adminContact/pages/ContactDetailsPage";
import AssetDetailsPage from "../features/assets/pages/AssetDetailsPage";
import AssetHoldingsPage from "../features/assets/pages/AssetHoldingsPage";
import AssetStatementsPage from "../features/assets/pages/AssetStatementsPage";
import AssetDocumentsPage from "../features/assets/pages/AssetDocumentsPage";
import UserProfilePage from "../features/userProfile/pages/UserProfilePage";
import AssetResearchPage from "../features/assets/pages/AssetResearchPage";
import DocumentPreviewPage from "../features/documents/pages/DocumentPreviewPage";
import IpSettingsPage from "../features/adminPanel/pages/IpSettingsPage";
import useUserContextStore from "../store/userContextStore";


const UserProfileLayoutWrapper = () => {
  const globalUserContext = useUserContextStore((state) => state.context);

  const getLayout =()=>{
    return globalUserContext?.userProfileType === "ChangeForgotPassword"
    ? <PublicLayout />
    : <AssetLayout />;
  }

  return getLayout();
};

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/DocumentPreview/:type/:documentId" element={<DocumentPreviewPage />} />
        <Route element={<PublicLayout />}>
          <Route path="/" element={<LoginPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/mfa-setup" element={<MfaSetupPage/>}/>
          <Route path="/mfa-verification" element={<MfaVerificationPage/>}/>
        </Route>
        <Route element={<AdminLayout/>}>
          <Route path="/AdminContact" element={<AdminContactPage />} />
          <Route path="/AdminContact/:contactId" element={<ContactDetailsPage/>}/>
          <Route path="/AdminDocument" element={<AdminDocumentPage/>}/>
          <Route path="/Email" element={<AdminEmailPage/>}/>
          <Route path="/WebUserAdmin" element={<AdminPanel/>}/>
          <Route path="/IPSettings" element={<IpSettingsPage/>}/>
        </Route>


        <Route path="/Asset" element={<AssetLayout />}>
          <Route path="Overview/:contactId" element={<AssetOverviewPage />} />
          <Route path="Details/:contactId" element={<AssetDetailsPage />} />
          <Route path="Holdings/:contactId" element={<AssetHoldingsPage />} />
          
        </Route>
        
          <Route element={<AssetLayout/>}>
          <Route path="Statements/:contactId" element={<AssetStatementsPage/>}/>
          <Route path="Documents/:contactId" element={<AssetDocumentsPage/>}/>
          <Route path="Research/:contactId" element={<AssetResearchPage/>}/>
        </Route>

        <Route path="/UserProfile" element={<UserProfileLayoutWrapper/>}>
          {/* <Route index element={<UserProfilePage />} /> */}
          <Route path=":contactId/:section" element={<UserProfilePage />} />
        </Route>

      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
